/* tslint:disable */
/* eslint-disable */
/* @relayHash f1c7d0a85b2a2646e010ee955126a15b */

import { ConcreteRequest } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type AcknowledgeWarningInput = {
    clientMutationId: string;
};
export type AcknowledgeWarningMutationVariables = {
    input: AcknowledgeWarningInput;
};
export type AcknowledgeWarningMutationResponse = {
    readonly acknowledgeWarning: {
        readonly user: {
            readonly id: string;
            readonly status: {
                readonly current: ReadonlyArray<USER_STATUS>;
                readonly warning: {
                    readonly active: boolean;
                };
            };
        };
        readonly clientMutationId: string;
    } | null;
};
export type AcknowledgeWarningMutation = {
    readonly response: AcknowledgeWarningMutationResponse;
    readonly variables: AcknowledgeWarningMutationVariables;
};



/*
mutation AcknowledgeWarningMutation(
  $input: AcknowledgeWarningInput!
) {
  acknowledgeWarning(input: $input) {
    user {
      id
      status {
        current
        warning {
          active
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "AcknowledgeWarningPayload",
            "kind": "LinkedField",
            "name": "acknowledgeWarning",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "current",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WarningStatus",
                                    "kind": "LinkedField",
                                    "name": "warning",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AcknowledgeWarningMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AcknowledgeWarningMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "f1c7d0a85b2a2646e010ee955126a15b",
            "metadata": {},
            "name": "AcknowledgeWarningMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3eab0489c80a7a2b3f38e415a10997c5';
export default node;
